import { createAction } from 'typesafe-actions';

export const SWITCH_MODAL = 'modal/SWITCH_MODAL';
export const OPEN_FROM_BANNER = 'modal/OPEN_FROM_BANNER';

export const switchModal = createAction(SWITCH_MODAL)<boolean>();
export const openFromBanner = createAction(OPEN_FROM_BANNER)();
